import { useMemo } from 'react'

import { useTheme } from '@chakra-ui/react'
import moment from 'moment'
import { ClockIcon } from '@verbit-ai/icons-library'

import { useTranscriptMetadata } from 'src/contexts/Transcript/MetadataContext'
import { durationHumanize } from 'src/utils/dates'

import * as S from './styles'

type SessionDetailsProps = {
    maxWidth: number
}

export const SessionDetails = (props: SessionDetailsProps) => {
    const { maxWidth } = props
    const metadata = useTranscriptMetadata()
    const {
        palette: {
            toolbar: { sessionDetailsColor },
        },
    } = useTheme()

    const [startDate, startTime, sessionDuration] = useMemo(() => {
        let date = ''
        let time = ''
        let duration = ''

        if (metadata) {
            const startMoment = moment(metadata.sessionStartAt)
            date = startMoment.format('MMM DD, YYYY')
            time = startMoment.format('hh:mm A')

            if (metadata.sessionFinishedAt) {
                duration = durationHumanize(moment(metadata.sessionFinishedAt).diff(startMoment, 'seconds'))
            }
        }

        return [date, time, duration]
    }, [metadata])

    return (
        <S.Panel>
            <S.ContentLimiter $maxWidth={maxWidth}>
                <S.Timestamp>
                    {startDate}
                    <S.Ellipse />
                    {startTime}
                </S.Timestamp>
                {metadata?.viewMode === 'job' && sessionDuration && (
                    <S.Duration>
                        <ClockIcon color={sessionDetailsColor} />
                        {sessionDuration}
                    </S.Duration>
                )}
            </S.ContentLimiter>
        </S.Panel>
    )
}
